import { Curtains } from '../components/ProductBuilder/Section/SectionImage/Curtains';
import {
  HoneycombDayNight,
  HoneycombDual,
  HoneycombSkylight,
  HoneycombSmartFit,
  HoneycombSmartFitDayNight,
  HoneycombStandard,
  HoneycombVertical,
  HoneycombVerticleDaynight,
} from '../components/ProductBuilder/Section/SectionImage/Honeycomb';
import {
  RollerBlind,
  RollerBlindDayNight,
} from '../components/ProductBuilder/Section/SectionImage/Roller';
import { RomanBlinds } from '../components/ProductBuilder/Section/SectionImage/RomanBlinds';
import { Shutters } from '../components/ProductBuilder/Section/SectionImage/Shutters';
import { VenetianBlinds } from '../components/ProductBuilder/Section/SectionImage/VenetianBlinds';
import { ProductType } from '../constants/productTypes';

export type AllStateConfigType = {
  [key in ProductType]?: Function;
};

export const productImageConfig: AllStateConfigType = {
  'Roller Blind Single Chain': RollerBlind,
  'Roller Blind Single Chainless': RollerBlind,
  'Roller Blind Premium Chain': RollerBlind,
  'Roller Blind Day/Night Chain': RollerBlindDayNight,
  'Roller Blind Day/Night Chainless': RollerBlindDayNight,
  'Roller Blind Essentials Chain': RollerBlind,
  'Honeycomb Day/Night Corded': HoneycombDayNight,
  'Honeycomb Day/Night Cordless': HoneycombDayNight,
  'Honeycomb Day/Night Motorised': HoneycombDayNight,
  'Honeycomb Skylight': HoneycombSkylight,
  'Honeycomb Smartfit': HoneycombSmartFit,
  'Honeycomb SmartFit Day Night': HoneycombSmartFitDayNight,
  'Honeycomb Dual View Corded': HoneycombDual,
  'Honeycomb Dual View Cordless': HoneycombDual,
  'Honeycomb Dual View Motorised': HoneycombDual,
  'Honeycomb Standard Corded': HoneycombStandard,
  'Honeycomb Standard Cordless': HoneycombStandard,
  'Honeycomb Standard Cordloop': HoneycombStandard,
  'Honeycomb Standard Motorised': HoneycombStandard,
  'Honeycomb Vertical Day/Night': HoneycombVerticleDaynight,
  'Honeycomb Vertical': HoneycombVertical,

  'Tecwood Plantation Shutter': Shutters,

  'Roman Blinds Chain': RomanBlinds,
  'Roman Blinds Chainless': RomanBlinds,

  'Venetian Aluminium': VenetianBlinds,
  'Venetian PVC Corded': VenetianBlinds,
  'Venetian PVC Cordless': VenetianBlinds,
  'Venetian Timber Corded': VenetianBlinds,
  'Venetian Timber Cordless': VenetianBlinds,
  Curtain: Curtains,
  'Sheer Curtain': Curtains,
};
